export default {
    'diagram8-3a1': {
        'diagram-number': '8.',
        'elements': {
            'one': 'Almost every gene of the genome is present in every cell of the body, though only some are turned on',
            'two': 'Each cell type thus contains a unique mix of proteins – a subpopulation of all the proteins available to the cell',
            'three': 'The mix limits the cell to performing only its specific biological function (a liver cell is a liver cell, and a brain cell is a brain cell)',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram8/i18n/en.js